import EditorFetch from './Editor';

export default EditorFetch;
